import { useChannelContext } from "client/components/channel"
import ScheduledShowCard from "client/components/ScheduledShowCard"
import { ScheduledShow } from "client/graphql"
import { MINUTE_MS } from "shared/utils/formatTime"

import styles from "./UpcomingShowsList.module.css"

const DEFAULT_SHOW_THUMBNAIL_URL = "/static/showDefaultThumbnail.png"

// Don't display shows that are over 10 minutes old
const DISPLAY_PASSED_SHOW_MS = 10 * MINUTE_MS
export const getUpcomingShows = (shows: ScheduledShow[]) => {
  return shows.filter((show) => {
    return (
      Date.now() <
      new Date(show.startTime).getTime() + DISPLAY_PASSED_SHOW_MS
    )
  })
}

export type UpcomingShowsListProps = {
  displayFirstShow?: boolean
}

export const UpcomingShowsList = ({
  displayFirstShow = true,
}: UpcomingShowsListProps) => {
  const { scheduledShows, user } = useChannelContext()

  const upcomingShows = getUpcomingShows(scheduledShows)
  const showsToDisplay = upcomingShows.slice(displayFirstShow ? 0 : 1)

  if (showsToDisplay.length === 0) {
    return null
  }

  return (
    <section className={styles.upcomingShowsSection}>
      <h2 className="headline-sm text-color-primary">
        More upcoming shows
      </h2>
      <div className={styles.upcomingShowsList}>
        {showsToDisplay.map((upcomingShow) => {
          return (
            <ScheduledShowCard
              key={upcomingShow.createdAt}
              title={upcomingShow.title}
              scheduledStartDate={new Date(upcomingShow.startTime)}
              channelAvatarUrl={user.avatarUrl}
              channelName={user.displayName}
              thumbnailUrl={
                upcomingShow.splashImageUrl ?? DEFAULT_SHOW_THUMBNAIL_URL
              }
            />
          )
        })}
      </div>
    </section>
  )
}
